<template>
  <div id="app">
    <router-view />
    <AppToast
      :visible="toast.visible.value"
      :type="toast.type.value"
      :title="toast.title.value"
      :message="toast.message.value"
      :duration="toast.duration.value"
      @close="closeToast"
    />
  </div>
</template>

<script>
import AppToast from '@/components/common/Toast.vue'
import { ToastService } from '@/services/ToastService'

export default {
  name: 'App',
  components: {
    AppToast
  },
  setup () {
    const toast = ToastService.getState()

    const closeToast = () => {
      ToastService.close()
    }

    return {
      toast,
      closeToast
    }
  },
  mounted() {
    // Kiểm tra token khi tab trở nên active
    document.addEventListener('visibilitychange', this.checkTokenOnVisibilityChange);
    
    // Kiểm tra token khi khởi động
    this.checkTokenValidity();
    
    // Kiểm tra token định kỳ
    this.tokenCheckInterval = setInterval(this.checkTokenValidity, 5 * 60 * 1000); // 5 phút
  },
  
  beforeUnmount() {
    // Dọn dẹp
    document.removeEventListener('visibilitychange', this.checkTokenOnVisibilityChange);
    clearInterval(this.tokenCheckInterval);
  },
  
  methods: {
    // Kiểm tra khi tab trở thành active
    checkTokenOnVisibilityChange() {
      if (document.visibilityState === 'visible') {
        this.checkTokenValidity();
      }
    },
    
    // Kiểm tra token có hợp lệ không
    checkTokenValidity() {
      const token = localStorage.getItem('adminToken');
      if (!token) {
        // Nếu không có token và không ở trang đăng nhập
        if (!window.location.pathname.includes('/login')) {
          this.handleInvalidToken();
        }
        return;
      }
      
      // Phân tích JWT để kiểm tra hết hạn
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        const expiry = payload.exp * 1000; // Chuyển thành milliseconds
        
        // Nếu token đã hết hạn hoặc sắp hết hạn (còn 60 giây)
        if (Date.now() >= expiry - 60000) {
          this.handleInvalidToken();
        }
      } catch (error) {
        console.error('Lỗi khi phân tích token:', error);
        this.handleInvalidToken();
      }
    },
    
    handleInvalidToken() {
      // Đăng xuất người dùng
      localStorage.removeItem('adminToken');
      localStorage.removeItem('refreshToken');
      
      // Thông báo cho người dùng
      if (window.ToastService) {
        window.ToastService.error('Phiên làm việc đã hết hạn, vui lòng đăng nhập lại');
      }
      
      // Chuyển hướng đến trang đăng nhập
      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/login';
      }
    }
  }
}
</script>

<style>
body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    'Helvetica Neue', Arial, sans-serif;
}

* {
  box-sizing: border-box;
}
</style>
